// extracted by mini-css-extract-plugin
export default {"signupContainer":"SignupLayout_signupContainer__LJq4e","signupHeader":"SignupLayout_signupHeader__g9B6N","signupDescription":"SignupLayout_signupDescription__xUz9v"};